<!-- 労働条件通知書 -->
<template>
  <div style="margin-top:10px">
    <div v-for="item in list" :key="item.key">
      <el-row :gutter="0" style="background-color:#3cc6fa;text-align:center">
        <div class="table-header">{{item.title}}</div>
      </el-row>
      <el-table :data="item.itemContent" class="table-label" :show-header=false :row-class-name="c0003IsRowClass" :cell-style="c0003IsCellStyle" :cell-class-name="c0003IsCellClass" style="border-bottom: 1px solid #ccc;">
        <!-- <el-table-column width="30px"> -->
        <el-table-column width="30px">
          <template slot-scope="scope">
            <div>{{scope.row.itemName}}</div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <div>{{scope.row.contractText}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="!pageShow" style="padding-top: 5px;padding-bottom: 5px;padding-left: 5px;font-size: 12pt;">{{consentText}}</div>
    <div align="center">
      <!-- 戻るボタン -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 13px;width:20%" type="primary" @click="back_click">{{$t('MODULE.C0002_BTN_RETURN')}}</el-button>
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 13px;width:20%" type="primary" @click="createdPDF()">{{$t('MODULE.C0003_BTN_PRINT')}}</el-button>
    </div>
    <el-dialog style="margin-top: 5%" fullscreen :visible.sync="viewVisible" :close-on-click-modal="false" :show-close="false" width="100%" top="52px" height="120%">
      <Pdf :src="pdfUrl" @pdfClose="pdfClose"></Pdf>
    </el-dialog>
  </div>
</template>
<script>
import * as amsApi from "../api/c_0003"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
import css from "@/statics/css"
import pdf from '@/components/page/pdf'
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  mixins: [css],
  components: {
    Pdf: pdf
  },
  data() {
    return {
      obj: [],
      listLoading: false,
      pledgeCheck: false,//誓約チェック
      consentCheck: false,//同意チェック
      pageShow: true,
      list: [],
      issueDate:"",//発行日
      consentDate:"",//同意日時
      consentText:"",//同意項目表示
      recNo:"", //レコード番号
      //pdfFlag
      viewVisible: false,
      pdfUrl: '',
      pdfPath: '',
    }
  },
  created() {
    this.query();
  },
  methods: {
    // 検索
    query() {
      let params = {
         "jobDate": this.$route.query.jobDate,
         "fieldCd": this.$route.query.fieldCd,
         "fieldUserCd": this.$route.query.userCd,
         "storePositionCd": this.$route.query.storePositionCd
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)

      
      //検索処理
      amsApi.search(params).then(res => {
        //API数据
        this.list = this.formartListData(res.items.laberNoticeSet);
        if (res.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close()
          //return
          //返回之前页面
          //var returnParam = JSON.parse(localStorage.getItem('search_condition'));
          //var routerUrl = JSON.parse(localStorage.getItem('routerUrl'));
          //var vm = this;
          //vm.$router.push({ path: routerUrl, query: returnParam });
        }else if (res.code === 311) {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        } 
        loading.close();
      }).catch((err) => {
        //关闭loading
        loading.close();
      });
    },
    //整理API返回的数据
    formartListData(list) {
      //返回结构体
      // contractDetailSetList = [
      //                           { //contractDetailSet
      //                             key : "",
      //                             title : "",
      //                             itemContent : [
      //                                             {
      //                                               itemName : "",
      //                                               contractText : "",
      //                                             },
      //                                           ],
      //                           }
      //                         ]

      var contractDetailSetList = [];
      var contractDetailSetIndex = 0;
      for (let i = 0; i < list.length; i++) {
        var items = list[i];
        var itemContent = {
          itemName : "",
          contractText : "",
        }
        if (items.note != "" && items.note != null ) {
          var contractDetailSet = {
              key : "",
              title : "",
              itemContent : [],
          }
          contractDetailSet.key = contractDetailSetIndex;
          contractDetailSet.title = items.note;
          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;
          contractDetailSet.itemContent.push(itemContent);
          contractDetailSetList.push(contractDetailSet);
          contractDetailSetIndex ++;
        } else {
          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;
          contractDetailSetList[contractDetailSetIndex-1].itemContent.push(itemContent);
        }
      }
      //APIから「タイトル」が有る場合、タイトル様式を設定する
      //「契約文言」だけタイトル様式として表示する
      for (let i = 0; i < contractDetailSetList.length; i++) {
        var items = contractDetailSetList[i];
        if (items.title == "TITLE") {
          if (items.itemContent.length > 0) {
            items.title = items.itemContent[0].contractText;
            items.itemContent.splice(0, 1); //删除明细行和title重复的数据
          }
        }
      }
      return contractDetailSetList;
    },
    // 戻る処理
    back_click() {
      // var returnC0001Param = JSON.parse(localStorage.getItem('C0001search_condition'));
      // var vm = this;
      // vm.$router.push({ path: url.routerUrl_C0001, query: returnC0001Param  })
      //返回之前页面
      //var returnParam = JSON.parse(localStorage.getItem('search_condition'));
      //var routerUrl = JSON.parse(localStorage.getItem('routerUrl'));
      //var vm = this;
      //vm.$router.push({ path: routerUrl, query: returnParam });
      this.$router.go(-1);
    },
    //労働条件通知書の印刷
    createdPDF() {
      this.set_loading()

      let params = {}
      params.jobDate = this.$route.query.jobDate;
      params.fieldCd = this.$route.query.fieldCd;
      params.fieldUserCd = this.$route.query.userCd;
      params.storePositionCd = this.$route.query.storePositionCd;

      amsApi.getLaborNoticeOutput(params).then(res => {
        if (res.type == 'application/json') {
          var that = this
          const reader = new FileReader();
          reader.readAsText(res, 'utf-8');
          reader.onload = function (e) {
            const readerres = reader.result;
            const parseObj = JSON.parse(readerres);
            if (parseObj.code == 300) {
              //該当データはありません。
              that.$message.warning({ message: that.$t('COMMON.NO_TARGET_DATA'), showClose: true });
            }
          }
        } else {
          let fileUrl = {}
          let blob = new Blob([res], { type: "application/pdf;charset=UTF-8" });
          let url = window.URL.createObjectURL(blob)
          fileUrl.url = url
          //労働条件通知書.pdf
          fileUrl.name = this.$t('MODULE.C0003_PDF_NAME') + ".pdf"
          this.download(fileUrl)
        }
        this.close_loading()
      }).catch(() => {
        this.close_loading()
      });
    },
    pdfClose() {
      this.viewVisible = false
    },
    //pdfダウンロード
    download(file) {
      this.pdfUrl = file
      this.viewVisible = true
    },
    //表格行样式
    c0003IsRowClass({ row, rowIndex }) {
      return 'c0003IsRowClass';
    },
    //表格单元格样式
    c0003IsCellClass({ row, rowIndex }) {
      return 'c0003IsCellClass'
    },
    //表格第一列与第二列样式
    c0003IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'text-align:right;background:#d2eef8;'
      } else {
        return 'background:#fafafa;'
      }
    },
  }
}
</script>
<style scope>
/* 表格行样式 */
.c0003IsRowClass {
  padding: 0px;
}

.c0003IsCellClass {
  border: 1px;
  border-style: solid;
  border-color: #ccc;
  padding: 0px;
}
.c0003IsCellClass .cell {
  padding: 0px 8px;
}

</style>


// WEBPACK FOOTER //
// src/module/page/c_0003.vue